export default __webpack_public_path__ + "static/media/IMG_6342.32aeb268.jpg";